import React from 'react'
import { Container } from './container';
import { Split } from './split';
import { Logo } from '../../components/logo';
import { FooterLinks } from './footerlinks';
import { Link } from 'react-router-dom';
import { VSplit } from './vsplit';
import { LearnMore } from './learnmore';
import { ApiRef } from '../../fasades/apiref';
import './footer.css';

export class Footer extends React.Component {

    render() {
        return (
            <Container classes="ontop" topColor="rgb(46, 59, 255)" btnColor="rgb(16, 2, 57)" theme="dark">
                <Split>
                    <VSplit classes="vsplit-logo">
                        <Logo/>
                        <div className="copyright"><span className="cpy">©️</span>2026</div>
                    </VSplit>
                    <FooterLinks heading="Links">
                        <Link to="/#about">About Us</Link>
                        <Link to="/#needed">What We Need</Link>
                    </FooterLinks>
                    <FooterLinks heading="Docs">
                        <Link to="/docs/founder">About the founder</Link>
                        <Link to="/docs/buildingagents">Building Agents</Link>
                        <Link to="/docs/whylearning">Why learning</Link>
                        <Link to="/docs/pricing">Pricing</Link>
                        <Link to="/docs/terms">Terms and Conditions</Link>
                        <Link to="/docs/privacy">Privacy Policy</Link>
                    </FooterLinks>
                    <FooterLinks heading="API Ref">
                        <Link to="/apiref">Overview</Link>
                        <Link to="/apiref/streaming">Streaming Guide</Link>
                        {ApiRef.getAllEndpoints().map((endpoint, index) => (
                            <Link key={index} to={`/apiref/${endpoint.docurl}`}>
                                {endpoint.title}
                            </Link>
                        ))}
                    </FooterLinks>
                    <FooterLinks heading="Contact Info">
                        <span>✉️ Email</span>
                        <Link to="mailto:info@tigercity.ai">info@tigercity.ai</Link>
                    </FooterLinks>
                    <LearnMore to="/playground">Playground</LearnMore>
                </Split>
            </Container>
        );
    }
}

